"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailSendingStatus = void 0;
var EmailSendingStatus;
(function (EmailSendingStatus) {
    EmailSendingStatus["NULL"] = "NULL";
    EmailSendingStatus["BLOCKED"] = "BLOCKED";
    EmailSendingStatus["AUTO"] = "AUTO";
    EmailSendingStatus["MANUAL"] = "MANUAL";
})(EmailSendingStatus = exports.EmailSendingStatus || (exports.EmailSendingStatus = {}));
//# sourceMappingURL=email-sending-status.js.map